import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { LoggerService } from './services/logger.service';

@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {
    private static readonly RESET_INTERVAL_MS = 60000;
    private loggedErrors = 0;
    private lastErrorTime = 0;
    constructor(
        private loggerService: LoggerService,
        private zone: NgZone
    ) {
        super();
    }

    handleError(error) {
        if (error === undefined || error === null) {
            return;
        }

        const now = Date.now();
        if (now - this.lastErrorTime > CustomErrorHandlerService.RESET_INTERVAL_MS) {
            this.loggedErrors = 0;
        }
        this.lastErrorTime = now;

        if (this.loggedErrors > 5) {
            return;
        }
        this.loggedErrors++;
        this.zone.run(() => {
            const message = error?.message ?? this.stringifyError(error);
            const stack = error?.stack ?? '';
            this.loggerService.logError(stack.includes(message) ? stack : `${message}\n${stack}`);
        });

        super.handleError(error);

        throw error;
    }

    private stringifyError(error: unknown): string {
        if (typeof error === 'string') {
            return error;
        }
        try {
            return JSON.stringify(error);
        } catch {
            return String(error);
        }
    }
}
